<div class="slider" id="home">
  <div class="slider-content" *ngIf="isDesktop">
    <video
      #bgVideo
      autoplay
      muted
      playsinline
      loop
      preload="auto"
      id="bg-video"
    >
      <source src="assets/vander_risk_control.mp4" type="video/mp4">
    </video>
    <div class="control">
        <span class="material-symbols-outlined" (click)="muteUnmute(true)" *ngIf="!mute">volume_up</span>
        <span class="material-symbols-outlined" (click)="muteUnmute(false)" *ngIf="mute">no_sound</span>
    </div>
  </div>
  <div class="slider-content" *ngIf="!isDesktop">
    <video
      #bgVideo
      playsinline
      loop
      preload="auto"
      id="bg-video"
    >
      <source src="assets/vander_risk_control.mp4" type="video/mp4">
    </video>
    <div class="control-over" (click)="play(pause)">
    </div>
    <div class="control">
        <span class="material-symbols-outlined" *ngIf="pause">play_arrow</span>
    </div>
  </div>
</div>